import classnames from 'classnames2';
import { kebabCase } from 'lodash';
import React from 'react';
import { Icon } from '../../Icon';
import styles from './PaginationButton.scss';

function createPaginationButton(icon, displayName, style) {
  var PaginationButton = function PaginationButton(props) {
    return !props.visible ? React.createElement("div", {
      className: classnames(styles.container, styles[style])
    }) : React.createElement("div", {
      role: "button",
      "data-test": kebabCase(displayName),
      className: classnames(styles.container, styles[style]),
      onClick: props.onClick
    }, React.createElement(Icon, {
      icon: icon,
      className: styles.icon
    }));
  };

  PaginationButton.displayName = displayName;
  return PaginationButton;
}

export var NextPaginationButton = createPaginationButton('arrow-chevron-right', 'NextPaginationButton', 'nextButton');
export var PrevPaginationButton = createPaginationButton('arrow-chevron-left', 'PrevPaginationButton', 'prevButton');